export default {
	PROFILE_QUESTIONNAIRES: 'Profile-Questionnaires',
};
